import timezoneData from "V2.0/constants/timezones";

import { Field } from "V2.0/common/fieldset";
import { Listbox, ListboxOption } from "V2.0/common/listbox";

export default function TimezoneSelect(props) {
  const { timezone, onTimezoneChange, locked } = props;

  const handleChange = (value) => {
    const event = {
      target: { value },
    };
    onTimezoneChange(event);
  };

  return (
    <Field >
      {/* <label
        htmlFor="timezones"
        className="inline-block text-xs px-1 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-50 transition-colors ml-auto"
      >
        Timezone
      </label> */}
      <Listbox
        as="div"
        // className="my-2"
        name="timezone"
        id="timezones"
        onChange={handleChange}
        value={timezone}
        disabled={locked}
      >
        {timezoneData.map((timezone) => {
          return (
            <ListboxOption
              key={timezone}
              value={timezone}
            >
              {timezone}
            </ListboxOption>
          );
        })}
      </Listbox>
    </Field>
  );
}